import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Col, Row, Container, Image } from "react-bootstrap";
import { motion } from "framer-motion";


//Components
import Card from "../../components/Card/index";
import Title from "../../components/Title";
import Input from "../../components/Input/index";
import Button from "../../components/Button/index";

//Styles
import { TitlePage, ErrorMessage } from "./styles";

//Actions Function
import { login } from "../../redux/actions/login";

//Assets
import Logo from "../../assets/img/logo.svg";

const variants = {
  visible: () => ({
    opacity: 1,
    transition: { duration: 1, delay: 3 }
  })
}

const Login = () => {
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  const dispatch = useDispatch();
  const user = useSelector((state: {login: any}) => state.login);
  const history = useHistory();

  // useEffect(() => {
  //   // if(user.authorized){
  //   //   // history.push("/admin/dashboard")
  //   // }
  //   const actualVersion = JSON.parse(localStorage.getItem("version") || "[]");
  //   let showModal = false;

  //   if(actualVersion === []){
  //     showModal = true;
  //   } else {
  //     if(actualVersion.version === systemVersion.version){
  //       showModal = false;
  //     } else {
  //       showModal = true;
  //     }
  //   }

  //   localStorage.setItem("version", JSON.stringify({
  //     ...systemVersion,
  //     show: showModal
  //   }));
  // }, []);

  useEffect(() => {
    document.body.classList.add("body-login");

    return () => {
      document.body.classList.remove("body-login");
    };
  }, []);

  return (
    <Container className="vh-100 d-flex align-items-center justify-content-center">
      <Row>
        <Col lg="12">
          <Card>
            <Container>
              <Row>
                <Col xl="12" className="text-center  pt-4">
                  <motion.div
                    inherit={false}
                    initial={{
                      y: 160,
                      opacity: 1,
                      scale: 1.5
                    }}
                    animate={{
                      y: 0,
                      scale: 1
                    }}
                    transition={{
                      delay: 0.5,
                      duration: 1.5,
                      type: "tween"
                    }}
                  >
                    <Image src={Logo} style={{ height: 45 }} />
                  </motion.div>
                </Col>
                <motion.div
                  style={{
                    width: "100%"
                  }}
                  initial={{
                    opacity: 0
                  }}
                  animate={{
                    opacity: 1
                  }}
                  transition={{
                    delay: 2,
                    duration: 1
                  }}
                >
                  <Formik
                    initialValues={{
                      email: "",
                      password: ""
                    }}

                    onSubmit={async (values) => {
                      try {
                        await dispatch(login(values));
                        setError(false);
                        history.push("/admin/dashboard")
                      } catch (e) {
                        values.email = "";
                        values.password = "";
                        setError(true);
                      }
                    }}
                  >
                    {() => {
                      return(
                        <Form className="w-100">
                          <Col xl="12" className="text-center pt-5 ">
                            <TitlePage>Autenticação</TitlePage>
                          </Col>

                          <Col xl="12" className=" pt-3 ">
                            <Title>Usuário</Title>
                            <Field id="email" name="email" type="email" as={Input}/>
                          </Col>

                          <Col xl="12" className=" pt-3 ">
                            <Title>Senha</Title>
                            <Field id="password" name="password" type="password" as={Input}/>
                          </Col>
                          <Col xl="12" className=" pt-3 d-flex justify-content-end">
                            <Link to="/auth/recovery">Esqueci minha senha?</Link>
                          </Col>

                          {
                            error ?
                              <div className="w-100 d-flex justify-content-center mt-3">
                                <ErrorMessage>Seu email ou senha estão errados, tente novamente</ErrorMessage>
                              </div> : null
                          }
                          <Col xl="12" className=" pt-5">
                            <Button id="submit" type="submit">Entrar</Button>
                          </Col>
                        </Form>
                      )
                    }}
                  </Formik>
                </motion.div>
              </Row>
            </Container>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
